import {Injectable} from "@angular/core";

@Injectable({
  providedIn: `root`
})
export class StorageService{
  constructor() {
  }

  setItem(key: string, item: string): void {
    this.CurrentStorage.setItem(key, item);
  }

  getItem(key: string): string | null {
    return this.CurrentStorage.getItem(key);
  }

  setTypedItem(key: string, item: object): void {
    this.CurrentStorage.setItem(key, JSON.stringify(item));
  }

  getTypedItem<T>(key: string): T | undefined {
    const item = this.CurrentStorage.getItem(key);
    if (item != null) {
      return <T>JSON.parse(item);
    } else {
      return undefined;
    }
  }

  removeItem(key: string): void {
    this.CurrentStorage.removeItem(key);
  }

  private get CurrentStorage(): Storage {
    return localStorage;
  }
}
